/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {


  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $(document).foundation();
        new WOW().init();

        // Navigation bar MOBILE
        var $navItemDrop = $('.main-nav__drop');
        $navItemDrop.click(function(){
            $(this).parents().toggleClass("main-nav__item--active");
            return false;
       });

        //MENU GÓRNE

        //1 PROCENT
        // $('.main-nav__item--1_procent a').click(function(event){
        //       event.preventDefault();
        //        $( "#krs-menu" ).toggle();
        //        $(this).children("i").toggleClass( "fa-flip-vertical" );
        //   });


        // TABY POMÓŻ – DEEP LINKING
        var link_tab = window.location.hash.substr(1);
          console.log(link_tab);
      if(link_tab){
          $('[data-tabs]').eq(0).foundation('selectTab', $('#'+link_tab));
      }

       //  var counter = 1;
       //  while(counter < 6 ) {
       //    var myAnim = setInterval(function(){
       //    $(".1bg img").attr('src', animFrame[counter])}, 2);
       //    var counter = counter + 1;
       //    console.log(counter);
       // }
            // dynamiczne wielkości przy resizowaniu

          var the_window = $(window);
           var wiedza_row = $('#wiedza-row');

          // górne i dolne marginesy

          function donate_horizontal() {

             if (Foundation.MediaQuery.atLeast('medium')) {
                  var h_margins = (the_window.width() - wiedza_row.width()) / 2;

                  // $('#donate_horizontal').css({"margin-left": -h_margins-15, "width": the_window.width(), "padding-left": h_margins, "padding-right": h_margins});
                  $('#donate_horizontal').css({"margin-left": -h_margins-15, "width": the_window.width()});
             }
              // if (h_margins > 60) {
              //     console.log(h_margins);
              // } else {
              //     h_margins = 60;
              //     console.log(h_margins);
              // }

              // if (jQuery.browser.mobile != true) {
              //     $('.sidebars').css('top', h_margins);
              //     $('.text-content').css('height', the_window.height() - h_margins);
              //     $('#top').css('height', h_margins);
              //     $('.kurtyna').css('padding-top', h_margins);
              //     $('.start').css('height', h_margins);
              //     $('#photo2').attr('data-menu-offset', -h_margins - 55);
              //     $('body').height($('body').height() - the_window.height() + 100);

              // }

              // if (jQuery.browser.mobile == true) {
              //     $('.fade').css('height', ($('.photo-big').eq(2).height()) * 0.91);
              //     $('.text-content').css('height', ($('.photo-big').eq(2).height()) * 1.2);
              // }
              //alert(($('.photo-big').eq(2).height())*0.95));



              // $('#loading-screen').css('height', the_window.height());
              // $('#lalert').css('height', the_window.height());
              //$('.start').addClass('active');

            var donate_price = 100;

            $('.donate__price--input').focus(function() {
                if (!$(this).data("DefaultText")) $(this).data("DefaultText", $(this).val());
                if ($(this).val() != "" && $(this).val() == $(this).data("DefaultText")) $(this).val("");
            }).blur(function(){
                if ($(this).val() == "") $(this).val($(this).data("DefaultText"));
            }).keyup(function(){
                donate_price = $(this).val();
            });

            $(".donate__price").click(function() {
              $(".donate__price").removeClass("active");
              $(this).addClass("active");
              $(".sg-donate__equal-text span").text($(this).data("title"));
              donate_price = $(this).data("value");
            });

            $(".donate__button").click(function() {

              var url = $(this).data('url') + '/wspomoz_krok_1?amount='+donate_price;
              window.location = url;
            });

          };

          donate_horizontal();

          the_window.resize(function (e) {

              donate_horizontal();

          });



        //   if(the_window.width()<=640){


              

            //    $('.main-nav__drop').click(function(){

            //       $('.main-nav__item--drop ul').removeClass("main-nav__sub-menu--active");
            //        $(this).children("ul").toggleClass("main-nav__sub-menu--active");
            //        return false;
            //   });
        //   }


 $('#wiedza-o-raku__cat__wszystkie').click(function(){

    $(this).class('');

 });





// wiedza o raku cat menu -  zmienia active na wszystkie jeśli zadna cat nie jest wybrana
ile_kumpli = $('#wiedza-o-raku__cat__wszystkie').siblings().hasClass("current-menu-item");

if(ile_kumpli==false){
  $('#wiedza-o-raku__cat__wszystkie').addClass("current-menu-item");

}


/********* kampania społeczna 6 miesięcy – żyć czy umierać?*/

(function() {

// Localize jQuery variable
var jQuery;
var serwer = 'https://ruchspoleczny.org.pl/widget/';

/******** Load jQuery if not present *********/
if (window.jQuery === undefined || window.jQuery.fn.jquery !== '1.11.2') {
    var script_tag = document.createElement('script');
    script_tag.setAttribute("type","text/javascript");
    script_tag.setAttribute("src",
        "https://ajax.googleapis.com/ajax/libs/jquery/1.11.2/jquery.min.js");
    if (script_tag.readyState) {
      script_tag.onreadystatechange = function () { // For old versions of IE
          if (this.readyState == 'complete' || this.readyState == 'loaded') {
              scriptLoadHandler();
          }
      };
    } else {
      script_tag.onload = scriptLoadHandler;
    }
    (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(script_tag);
} else {
    jQuery = window.jQuery;
    main2();
}

/******** Called once jQuery has loaded ******/
function scriptLoadHandler() {
    jQuery = window.jQuery.noConflict(true);
    main2();
    bannerSlider();
}

function main2() {
    // $(document).ready(function($) {
    //     /******* Load CSS *******/
    //     var css_link = $("<link>", {
    //         rel: "stylesheet",
    //         type: "text/css",
    //         href: serwer+"baner.css"
    //     });
    //     css_link.appendTo('head');
    //     /******* Load HTML *******/
    //     var jsonp_url = serwer+"baner.php?callback=?";
    //     $.getJSON(jsonp_url, function(data) {
    //       $('#baner-widget').html(data);
    //     });
    //  // POPARCIE
    //     $('#baner-widget').on('click','#popieram', function(e) {
    //         e.preventDefault();
    //      // $.cookie( 'popieram', 'tak', { expires: 365, path: '/' } ); nie dziaÅ‚a cross-domain
    //         $('#ajax_inner').fadeOut('slow', function() {
    //           $.post(serwer+"popieram.ajax.php", { add: true , host: location.host, pop: '0' },
    //                  function(data) {
    //                    $('#ajax_inner').html(data).fadeIn('fast');
    //                  });
    //         });
    //     });
    // });
}

function bannerSlider() {
    $(document).ready(function($) {
        var slideInterval = setInterval(function(){
            moveRight();
        }, 8000);

        var slideWidth = "100%";
        var slideHeight = 350;
        var sliderUlWidth = "100%";

        $('#twoSlidesBanner').css({width: slideWidth, height: slideHeight});

        $('#twoSlidesBanner ul').css({width: sliderUlWidth});

        $('#twoSlidesBanner ul li:last-child').prependTo('#twoSlidesBanner ul');

        function moveLeft() {
            $('#twoSlidesBanner ul').animate({
                opacity: 0.25
            }, 250, function () {
                $('#twoSlidesBanner ul').animate({
                    opacity: 1
                }, 100);
                $('#twoSlidesBanner ul li:last-child').prependTo('#twoSlidesBanner ul');
            });
        };

        function moveRight() {
            $('#twoSlidesBanner ul').animate({
                opacity: 0.25
            }, 250, function () {
                $('#twoSlidesBanner ul').animate({
                    opacity: 1
                }, 100);
                $('#twoSlidesBanner ul li:first-child').appendTo('#twoSlidesBanner ul');
            });
        };

        $('a.control_prev').click(function (event) {
            event.preventDefault();
            moveLeft();
            sliderResetInterval();
        });

        $('a.control_next').click(function (event) {
            event.preventDefault();
            moveRight();
            sliderResetInterval();
        });
        function sliderResetInterval() {
            clearInterval(slideInterval);
            slideInterval = setInterval(function () {
                moveRight();
            }, 8000);
        }
    });
}

})();



// *******
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.



